const CarrierRegistrationTypes = {
  REGISTER_EMAIL_PROGRESS: 'CARRIER_REGISTRATION_TYPES.REGISTER_EMAIL_PROGRESS',
  REGISTER_EMAIL_SUCCESS: 'CARRIER_REGISTRATION_TYPES.REGISTER_EMAIL_SUCCESS',
  REGISTER_EMAIL_ERROR: 'CARRIER_REGISTRATION_TYPES.REGISTER_EMAIL_ERROR',
  GET_REGISTER_EMAIL_PROGRESS: 'CARRIER_REGISTRATION_TYPES.GET_REGISTER_EMAIL_PROGRESS',
  GET_REGISTER_EMAIL_SUCCESS: 'CARRIER_REGISTRATION_TYPES.GET_REGISTER_EMAIL_SUCCESS',
  GET_REGISTER_EMAIL_ERROR: 'CARRIER_REGISTRATION_TYPES.GET_REGISTER_EMAIL_ERROR',
  DEACTIVATE_REGISTER_EMAIL_PROGRESS: 'CARRIER_REGISTRATION_TYPES.DEACTIVATE_REGISTER_EMAIL_PROGRESS',
  DEACTIVATE_REGISTER_EMAIL_SUCCESS: 'CARRIER_REGISTRATION_TYPES.DEACTIVATE_REGISTER_EMAIL_SUCCESS',
  DEACTIVATE_REGISTER_EMAIL_ERROR: 'CARRIER_REGISTRATION_TYPES.DEACTIVATE_REGISTER_EMAIL_ERROR',
};

export default CarrierRegistrationTypes;
